import { Endpoint } from "../config";

export type NotificationEndpointType =
  | "markAsReadNotification"
  | "markAllAsRead"
  | "notificationList";

export const notificationEndpoints: Record<NotificationEndpointType, Endpoint> =
  {
    markAsReadNotification: {
      url: "notifications/mark-as-read",
    },
    markAllAsRead: {
      url: "notifications/mark-all-as-read/",
    },
    notificationList: {
      url: "notifications/",
    },
  };
